import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const categoryImages: Record<string, { icon: string; bg: string }> = {
  movie: {
    icon: 'ri-film-line',
    bg: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20warm%20golden%20light%2C%20movie%20theater%20atmosphere%2C%20dramatic%20lighting%2C%20dark%20cinematic%20background%20with%20film%20strip%20texture&width=600&height=400&seq=cat-movie-bg&orientation=landscape',
  },
  tv: {
    icon: 'ri-tv-line',
    bg: 'https://readdy.ai/api/search-image?query=Television%20studio%20with%20warm%20lighting%2C%20drama%20series%20production%20set%2C%20cozy%20home%20entertainment%20vibe%2C%20cinematic%20quality%20warm%20amber%20tones&width=600&height=400&seq=cat-tv-bg&orientation=landscape',
  },
  anime: {
    icon: 'ri-emotion-line',
    bg: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20illustration%20with%20vibrant%20warm%20colors%2C%20dynamic%20animation%20cel%20aesthetic%2C%20artistic%20background%20with%20cherry%20blossom%20and%20warm%20sunset&width=600&height=400&seq=cat-anime-bg&orientation=landscape',
  },
  variety: {
    icon: 'ri-movie-line',
    bg: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20warm%20lights%2C%20entertainment%20show%20atmosphere%2C%20concert%20lighting%2C%20dynamic%20stage%20design%20with%20spotlights&width=600&height=400&seq=cat-variety-bg&orientation=landscape',
  },
};

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => {
            const img = categoryImages[cat.slug];
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative h-28 md:h-36 rounded-xl overflow-hidden cursor-pointer"
              >
                <img
                  src={img.bg}
                  alt={cat.name}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/20"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="flex items-center gap-2">
                    <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/20">
                      <i className={`${img.icon} text-base text-primary-400`}></i>
                    </span>
                    <span className="text-base md:text-lg font-heading font-semibold text-foreground-50">
                      {cat.name}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}